import React, { useState, useEffect } from "react";
import vozoExploreIcon from "../../assets/images/vozo-explore-icon.png";
import { Div } from "./styles";
import { Modal } from "react-bootstrap";
import UserGuide from "../popups/UserGuide";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt/index.js";
import { useHistory, useLocation } from "react-router-dom";

const ExploreWidget = ({ explore }) => {
  //------------------------------------------State and Variables Start------------------------------------------//

  const [showuserguide, setshowuserguide] = useState(false);
  const provname = localStorage.getItem("provider_name")
    ? Decrypt_Value(localStorage.getItem("provider_name"), "vozo")
    : "";
  const expired_days = localStorage.getItem("expired_days")
    ? Decrypt_Value(localStorage.getItem("expired_days"), "vozo")
    : "";
  const location = useLocation();
  let history = useHistory();

  //------------------------------------------State and Variables End------------------------------------------//
  // ------------------------------- Functions Start--------------------------------------------------------- //

  const handleCloseApp = () => setshowuserguide(false);
  // ------------------------------- Functions End--------------------------------------------------------- //
  useEffect(() => {
    if (location?.state?.getstartedopen === true) {
      setshowuserguide(true);
      history.replace({ ...location, state: {} });
    }
  }, [location?.state?.getstartedopen]);

  useEffect(() => {
    const handleOpenUserGuide = () => setshowuserguide(true);
    window.addEventListener("openUserGuidePopup", handleOpenUserGuide);

    return () => {
      window.removeEventListener("openUserGuidePopup", handleOpenUserGuide);
    };
  }, []);
  return (
    <>
      <Div className={explore}>
        <img src={vozoExploreIcon} className="explore-vozo-img" alt="logo" />
        <h1 className="explore-vozo-heading">Explore Vozo</h1>
        <p className="explore-vozo-para">Follow these steps to get running</p>
        <button
          className="explore-vozo-button"
          onClick={() => {
            setshowuserguide(true);
            history.push({
              pathname: location.pathname,
              state: {
                patientportalstarted: false,
              },
            });
          }}
          disabled={expired_days < 0}
        >
          Get Started
        </button>
      </Div>
      <Modal
        style={{
          zIndex: 9999,
        }}
        // className="zIndex1100"
        show={showuserguide}
        onHide={() => setshowuserguide(false)}
      >
        <UserGuide close={handleCloseApp} ProviderName={provname} />
      </Modal>
    </>
  );
};

export default ExploreWidget;
